// extracted by mini-css-extract-plugin
export var cardHeader = "_ew-0";
export var reorderHandle = "_ew-3";
export var titleArea = "_ew-1";
export var titleAreaWithHandle = "_ew-2";